import { SaveStateTypeEnum } from "src/app/shared/Models/enums/SaveStateTypeEnum";
import { BulkConfigurationType } from "./BulkConfigurationType.enum";

export class BulkConfigurationSettingDto {
  type: BulkConfigurationType;
  shortName: string;
  displayName: string;
  partnerAccessAllowed: boolean;

  state?: SaveStateTypeEnum;
}
